import { render } from "./Support.vue?vue&type=template&id=16509658&ts=true"
import script from "./Support.vue?vue&type=script&lang=ts"
export * from "./Support.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__